import {API_URL} from "../config/appConfig";
import {
  AuthenticateApi as GeneratedAuthenticateApi,
  Configuration,
  IssuersApi,
  OrganizationsApi,
  OrganizationStagesApi,
  OrganizationUserApi,
  UtilitiesApi,
  IssuerDocumentApi
} from "../generated/api";

const accessTokenKey = "nfn-access-token";

const configuration = new Configuration({
  accessToken: localStorage.getItem(accessTokenKey) || undefined,
  baseOptions: { withCredentials: true },
  basePath: API_URL
});

export class AuthenticateApi extends GeneratedAuthenticateApi {
  public setAccessToken(accessToken: string) {
    localStorage.setItem(accessTokenKey, accessToken);
    configuration.accessToken = accessToken;
  }
}

export const authenticateApi = new AuthenticateApi(configuration);
export const issuersApi = new IssuersApi(configuration);
export const organizationsApi = new OrganizationsApi(configuration);
export const organizationStagesApi = new OrganizationStagesApi(configuration);
export const organizationUserApi = new OrganizationUserApi(configuration);
export const utilitiesApi = new UtilitiesApi(configuration);
export const issuerDocumentApi = new IssuerDocumentApi(configuration);